/**
 * Storage modulo-level per "richieste foto orfane".
 *
 * Una richiesta foto è "orfana" quando l'utente desktop chiude la modale
 * RemotePhotoRequest dopo che l'operatore mobile ha accettato ma prima che
 * la foto sia arrivata. Senza questo registro, l'evento
 * `request_completed_by_mobile` arriverebbe sul WebSocket condiviso ma
 * nessun handler locale lo gestirebbe → foto persa lato UI.
 *
 * L'OrphanPhotoWatcher (registrato a livello App.tsx) ascolta gli eventi
 * `request_completed_by_mobile` e, se il requestId è orfano, scarica
 * automaticamente la foto sul disco dell'utente e mostra un toast.
 */

export interface OrphanRequestMeta {
  title: string;
  from: string; // nome operatore richiedente o destinatario
}

const orphanRequests = new Map<string, OrphanRequestMeta>();

export function markOrphanRequest(requestId: string, meta: OrphanRequestMeta): void {
  if (!requestId) return;
  orphanRequests.set(requestId, meta);
  console.log('[OrphanPhoto] requestId marcato orfano:', requestId, meta);
}

export function isOrphanRequest(requestId: string): boolean {
  return orphanRequests.has(requestId);
}

export function getOrphanRequestMeta(requestId: string): OrphanRequestMeta | undefined {
  return orphanRequests.get(requestId);
}

export function clearOrphanRequest(requestId: string): void {
  orphanRequests.delete(requestId);
}
